// extracted by mini-css-extract-plugin
module.exports = {"main":"FeaturedProducts_main____hKl","heading":"FeaturedProducts_heading__n59sa","cards-container":"FeaturedProducts_cards-container___thi2"};